const cancelBookingToast = (state = null, action) => {
  if (action.type === "SET_CANCEL_BOOKING_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CANCEL_BOOKING_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default cancelBookingToast;
